import AdminTournamentEditPage from "./AdminTournamentEditPage";

/** Alta de torneo = el MISMO Paso 1 que la edición (Eduardo 2026-09-08: "sólo
 * hay 1 paso 1"): sedes, logo, póster y banners se capturan aquí y se suben
 * en cuanto el torneo existe. */
export default function AdminTournamentNewPage() {
  return <AdminTournamentEditPage mode="create" />;
}
